import styled from 'styled-components';
import frame from './FRAME.png';

const Frame = styled.div`
  height: 762px;
  width: 762px;
  position: relative;
  background-image: url(${frame});
`;

export default Frame;
